import { useParams } from 'react-router-dom';
import { StepForwardOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { snapStore } from 'containers/Snaps/Snap/store';

import { useStartCorrection } from 'hooks';

export const NextSnapButton = () => {
  const isNextSnapVisible = snapStore((state) => state.snapBooleanStatuses.isNextSnapVisible);
  const isNextSnapAllowed = snapStore((state) => state.snapBooleanStatuses.isNextSnapAllowed);

  const { snapId } = useParams();

  const [handleGetCorrection, { loading }] = useStartCorrection();

  if (!isNextSnapVisible) {
    return null;
  }

  return (
    <Button
      size='small'
      loading={loading}
      disabled={!isNextSnapAllowed}
      onClick={() => handleGetCorrection({ callbackQueryParams: { previousSnapId: snapId } })}
    >
      Next Snap

      <StepForwardOutlined />
    </Button>
  );
};
